import { ModelNumbers } from '../Atdm0604';
class Atdm0604ValueCollection {
    constructor(index, values, strIdxs = []) {
        this.index = index;
        this.values = values;
        this.strIdxs = strIdxs;
    }
    getValues() {
        const sendValues = this.values.map((v, idx) => {
            return this.strIdxs.includes(idx) ? `"${v}"` : v;
        });
        if (this.index !== undefined)
            sendValues.unshift(`${this.index}`);
        return sendValues.join(',');
    }
    setValues(values) {
        for (let i = 0; i < values.length; i++) {
            if (i > this.values.length || values[i] === '')
                continue;
            this.values[i] = values[i].trim();
        }
    }
}
class ArrayMicChannel {
    constructor() {
        this.mute = new Atdm0604ValueCollection(undefined, ['0']);
    }
}
class InputChannel {
    constructor(index, name) {
        this.index = index;
        this.name = name;
        this.gainLevel = new Atdm0604ValueCollection(index, [
            '0',
            '0',
            '0',
            '0',
            '0',
            '0',
            '0', // 6: undocumented
        ]);
        this.settings = new Atdm0604ValueCollection(index, [
            '0',
            '0',
            '0',
            '0',
            '0',
            '0',
            '1',
            '1',
            '1',
            '0',
            '0',
            '0',
            '0',
            '0',
            '0',
            '0',
            '0',
            '0',
            name,
            '2E8050', // 19: channelColor
        ], [18]);
        if (index === '10') {
            this.settings.values[0] = '3'; // inputSource
            this.settings.values[6] = '0'; // link56
        }
    }
}
class InputChannels {
    constructor() {
        this.channels = [];
    }
    add(index, name) {
        this.channels.push(new InputChannel(index, name));
    }
    get(index) {
        for (const channel of this.channels) {
            if (channel.index === index)
                return channel;
        }
        return undefined;
    }
}
class OutputChannel {
    constructor(index, name) {
        this.index = index;
        this.name = name;
        this.level = new Atdm0604ValueCollection(index, [
            '0',
            '0',
            '0', // 2: maxVolume
        ]);
        this.mute = new Atdm0604ValueCollection(index, ['0']);
        this.settings = new Atdm0604ValueCollection(index, [
            '0',
            name,
            '2E8050', // 2: channelColor
        ], [1]);
    }
}
class OutputChannels {
    constructor() {
        this.channels = [];
    }
    add(index, name) {
        this.channels.push(new OutputChannel(index, name));
    }
    get(index) {
        for (const channel of this.channels) {
            if (channel.index === index)
                return channel;
        }
        return undefined;
    }
}
class PresetChannel {
    constructor(index, name) {
        this.index = index;
        this.name = name;
        this.settings = new Atdm0604ValueCollection(index, [name], [0]);
    }
}
class PresetChannels {
    constructor() {
        this.channels = [];
    }
    add(index, name) {
        this.channels.push(new PresetChannel(index, name));
    }
    get(index) {
        for (const channel of this.channels) {
            if (channel.index === index)
                return channel;
        }
        return undefined;
    }
}
class UsbOutputChannel {
    constructor() {
        this.settings = new Atdm0604ValueCollection(undefined, ['0', '0']);
    }
}
export class Atdm0604 {
    constructor(socket, log) {
        this.socket = socket;
        this.arrayMic = new ArrayMicChannel();
        this.firmwareVersion = '01.01.02';
        this.inputChannels = new InputChannels();
        this.outputChannels = new OutputChannels();
        this.presetChannels = new PresetChannels();
        this.usbOutput = new UsbOutputChannel();
        this.asyncHandlers = [
            {
                regExp: /^call_preset S 0000 00 NC (\d+)/,
                callback: (match) => {
                    const channel = this.presetChannels.get(match[1]);
                    if (channel === undefined) {
                        this.socket.send('call_preset NAK 04');
                        return;
                    }
                    this.socket.send('call_preset ACK');
                },
            },
            {
                regExp: /^g_arraymic_mute O 0000 00 NC/,
                callback: (match) => {
                    const mute = this.arrayMic.mute.getValues();
                    this.socket.send(`g_arraymic_mute 0000 00 NC ${mute}`);
                },
            },
            {
                regExp: /^g_firmware_version O 0000 00 NC/,
                callback: (match) => {
                    this.socket.send(`g_firmware_version 0000 00 NC ${this.firmwareVersion}`);
                },
            },
            {
                regExp: /^g_input_channel_settings O 0000 00 NC (\d+)/,
                callback: (match) => {
                    const channel = this.inputChannels.get(match[1]);
                    if (channel === undefined) {
                        this.socket.send('g_input_channel_settings NAK 04');
                        return;
                    }
                    const settings = channel.settings.getValues();
                    this.socket.send(`g_input_channel_settings 0000 00 NC ${settings}`);
                },
            },
            {
                regExp: /^g_input_gain_level O 0000 00 NC (\d+)/,
                callback: (match) => {
                    const channel = this.inputChannels.get(match[1]);
                    if (channel === undefined) {
                        this.socket.send('g_input_channel_settings NAK 04');
                        return;
                    }
                    const gainLevel = channel.gainLevel.getValues();
                    this.socket.send(`g_input_gain_level 0000 00 NC ${gainLevel}`);
                },
            },
            {
                regExp: /^g_mute O 0000 00 NC/,
                callback: (match) => {
                    const mute = this.arrayMic.mute.getValues();
                    this.socket.send(`g_mute 0000 00 NC ${mute}`);
                },
            },
            {
                regExp: /^g_name_bank O 0000 00 NC/,
                callback: (match) => {
                    const len = this.presetChannels.channels.length;
                    for (let i = 0; i < len; i++) {
                        const preset = this.presetChannels.channels[i];
                        const msg = i == 0 ? 'S' : i < len - 1 ? 'M' : 'E';
                        const settings = preset.settings.getValues();
                        this.socket.send(`g_name_bank 0000 00 C${msg} ${settings}`);
                    }
                },
            },
            {
                regExp: /^g_output_level O 0000 00 NC (\d+)/,
                callback: (match) => {
                    const channel = this.outputChannels.get(match[1]);
                    if (channel === undefined) {
                        this.socket.send('g_output_level NAK 04');
                        return;
                    }
                    const level = channel.level.getValues();
                    this.socket.send(`g_output_level 0000 00 NC ${level}`);
                },
            },
            {
                regExp: /^g_output_channel_settings O 0000 00 NC (\d+)/,
                callback: (match) => {
                    const channel = this.outputChannels.get(match[1]);
                    if (channel === undefined) {
                        this.socket.send('g_output_channel_settings NAK 04');
                        return;
                    }
                    const settings = channel.settings.getValues();
                    this.socket.send(`g_output_channel_settings 0000 00 NC ${settings}`);
                },
            },
            {
                regExp: /^g_output_mute O 0000 00 NC (\d+)/,
                callback: (match) => {
                    const channel = this.outputChannels.get(match[1]);
                    if (channel === undefined) {
                        this.socket.send('g_output_mute NAK 04');
                        return;
                    }
                    const mute = channel.mute.getValues();
                    this.socket.send(`g_output_mute 0000 00 NC ${mute}`);
                },
            },
            {
                regExp: /^g_usb_out O 0000 00 NC/,
                callback: (match) => {
                    const mute = this.usbOutput.settings.getValues();
                    this.socket.send(`g_usb_out 0000 00 NC ${mute}`);
                },
            },
            {
                regExp: /^identify S 0000 00 NC/,
                callback: (match) => {
                    this.socket.send('identify ACK');
                },
            },
            {
                regExp: /^s_arraymic_mute S 0000 00 NC (\d+)/,
                callback: (match) => {
                    this.arrayMic.mute.setValues([match[1]]);
                    this.socket.send('s_arraymic_mute ACK');
                },
            },
            {
                regExp: /^s_input_channel_settings S 0000 00 NC (\d+),(.+)/,
                callback: (match) => {
                    const channel = this.inputChannels.get(match[1]);
                    if (channel === undefined) {
                        this.socket.send('s_input_channel_settings NAK 04');
                        return;
                    }
                    channel.settings.setValues(match[2].split(','));
                    this.socket.send('s_input_channel_settings ACK');
                },
            },
            {
                regExp: /^s_input_gain_level S 0000 00 NC (\d+),(.+)/,
                callback: (match) => {
                    const channel = this.inputChannels.get(match[1]);
                    if (channel === undefined) {
                        this.socket.send('s_input_gain_level NAK 04');
                        return;
                    }
                    channel.gainLevel.setValues(match[2].split(','));
                    this.socket.send('s_input_gain_level ACK');
                },
            },
            {
                regExp: /^s_mute S 0000 00 NC (0|1)/,
                callback: (match) => {
                    this.arrayMic.mute.setValues([match[1]]);
                    this.socket.send('s_mute ACK');
                },
            },
            {
                regExp: /^s_output_level S 0000 00 NC (\d+),(.+)/,
                callback: (match) => {
                    const channel = this.outputChannels.get(match[1]);
                    if (channel === undefined) {
                        this.socket.send('s_output_level NAK 04');
                        return;
                    }
                    channel.level.setValues(match[2].split(','));
                    this.socket.send('s_output_level ACK');
                },
            },
            {
                regExp: /^s_output_channel_settings S 0000 00 NC (\d+),(.+)/,
                callback: (match) => {
                    const channel = this.outputChannels.get(match[1]);
                    if (channel === undefined) {
                        this.socket.send('s_output_channel_settings NAK 04');
                        return;
                    }
                    channel.settings.setValues(match[2].split(','));
                    this.socket.send('s_output_channel_settings ACK');
                },
            },
            {
                regExp: /^s_output_mute S 0000 00 NC (\d+),(.+)/,
                callback: (match) => {
                    const channel = this.outputChannels.get(match[1]);
                    if (channel === undefined) {
                        this.socket.send('s_output_mute NAK 04');
                        return;
                    }
                    channel.mute.setValues(match[2].split(','));
                    this.socket.send('s_output_mute ACK');
                },
            },
            {
                regExp: /^s_powersave S 0000 00 NC (0|1)/,
                callback: (match) => {
                    this.socket.send('s_powersave ACK');
                },
            },
            {
                regExp: /^s_usb_out S 0000 00 NC (\d+)/,
                callback: (match) => {
                    this.usbOutput.settings.setValues([match[1]]);
                    this.socket.send('s_usb_out ACK');
                },
            },
            {
                regExp: /(.+)/,
                callback: (match) => {
                    this.socket.send(match[1].split(' ')[0] + ' NAK 01');
                },
            },
        ];
    }
    onConfigure(config) {
        if ((config === null || config === void 0 ? void 0 : config.equipmentType) === ModelNumbers.Atdm0604) {
            for (let i = 0; i < 6; i++) {
                this.inputChannels.add(`${i}`, `CH ${i + 1}`);
            }
            this.inputChannels.add('10', 'AUX');
            for (let i = 0; i < 2; i++) {
                this.outputChannels.add(`${i}`, `OUT ${i + 1}`);
            }
            this.outputChannels.add('10', 'OUT ST');
            for (let i = 0; i < 6; i++) {
                this.presetChannels.add(`${i + 1}`, `Preset ${i + 1}`);
            }
        }
        else if ((config === null || config === void 0 ? void 0 : config.equipmentType) === ModelNumbers.Atnd1061) {
            for (let i = 0; i < 6; i++) {
                this.inputChannels.add(`${i}`, `Dante CH ${i + 1}`);
            }
            this.outputChannels.add('0', `Analog OUT`);
            this.outputChannels.add('1', `Auto Mix OUT`);
            for (let i = 0; i < 16; i++) {
                this.presetChannels.add(`${i + 1}`, `Preset ${i + 1}`);
            }
        }
    }
}
Atdm0604.emulatorType = 'socketEmulator';
Atdm0604.key = '-MEwcGPlXG9dOjkk74Sm';
